export default {
      id: "action-usage",
      viewBox: "0 0 12 4",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#action",
      toString: function () {
        return this.url;
      }
    }